import { MarketCalendar } from '@/components/calendar/MarketCalendar'

import styles from './PortalPages.module.css'

/**
 * Public market calendar — same view as the home page calendar, without admin tools.
 */
export function CalendarPage() {
  return (
    <section className={styles.page}>
      <header className={styles.header}>
        <div>
          <p className={styles.brand}>Oikos Market Day</p>
          <h1 className={styles.title}>Calendar</h1>
          <p className={styles.lead}>
            Upcoming market days and local events — tap a highlighted day for details and vendors.
          </p>
        </div>
      </header>
      <MarketCalendar />
    </section>
  )
}
